import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Box, Typography, Button, Paper } from '@mui/material';
import { Lock as LockIcon } from '@mui/icons-material';
import { ROUTES_NAMES } from './Layout';

interface TrackerRouteProps {
    children: React.ReactNode;
}

const TrackerRoute: React.FC<TrackerRouteProps> = ({ children }) => {
    const { isAuthenticated, hasProductAccess, getDefaultRoute } = useAuth();
    const navigate = useNavigate();

    if (!isAuthenticated) {
        return <Navigate to={ROUTES_NAMES.AUTH} replace />;
    }

    if (!hasProductAccess('tracker')) {
        const defaultRoute = getDefaultRoute();

        return (
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '100vh',
                    backgroundColor: '#ffffff',
                    p: 3,
                }}
            >
                <Paper
                    elevation={3}
                    sx={{
                        p: 4,
                        maxWidth: 450,
                        textAlign: 'center',
                        borderRadius: 2,
                    }}
                >
                    <LockIcon sx={{ fontSize: 64, color: 'text.secondary', mb: 2 }} />
                    <Typography variant="h5" gutterBottom fontWeight="bold">
                        Tracker no disponible
                    </Typography>
                    <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                        No tienes acceso al Tracker de marcas.
                    </Typography>
                    {defaultRoute !== '/auth' && (
                        <Button
                            variant="contained"
                            onClick={() => navigate(defaultRoute)}
                            sx={{ mt: 1 }}
                        >
                            Ir a inicio
                        </Button>
                    )}
                </Paper>
            </Box>
        );
    }

    return <>{children}</>;
};

export default TrackerRoute;
